import api from '@/apis'
import Vuetify from '@/plugins/vuetify'
import router from '@/router'

export default {
  state: {
    table: {
      selected: null,
      loading: false,
      headers: [{ title: 'Current Live Video Call', value: 'name', sortable: false, class: 'live-video-header' }],
      items: []
    },
    video_iframe: {
      visibility: false
    },
    offline_hours: null,
    notification_channel: null,
    notification_options: null,
    offline_responses: null
  },
  mutations: {
    SET_LIVE_VIDEO_TABLE_LOADING(state, payload) {
      state.table.loading = payload
    },
    SET_LIVE_VIDEO_TABLE_ITEMS(state, payload) {
      state.table.items = payload
    },
    SET_LIVE_VIDEO_TABLE_SELECTED(state, payload) {
      state.table.selected = payload
    },
    SET_LIVE_VIDEO_IFRAME_VISIBILITY(state, payload) {
      state.video_iframe.visibility = payload
    },
    SET_OFFLINE_HOUR(state, payload) {
      state.offline_hours = payload
    },
    SET_NOTIFICATION_CHANNEL(state, payload) {
      state.notification_channel = payload
    },
    SET_NOTIFICATION_OPTIONS(state, payload) {
      state.notification_options = payload
    },
    SET_OFFLINE_RESPONSES(state, payload) {
      state.offline_responses = payload
    }
  },
  actions: {
    selectVideoCall({ state, commit, dispatch }, { mode, item }) {
      if (mode === 'table') {
        dispatch('checkSelectedCallInNotificationBanner', item.real_session_id)
        commit('SET_LIVE_VIDEO_TABLE_SELECTED', state.table.selected?.real_session_id === item?.real_session_id ? null : item)
      } else if (mode === 'banner') {
        commit('RESET_NOTIFICATION_BANNER')
        router.push({ path: '/live_video' })
        const new_call = state.table.items.filter((call) => call.real_session_id === item)
        if (new_call.length > 0) commit('SET_LIVE_VIDEO_TABLE_SELECTED', new_call[0])
      }

      if (state.table.selected) {
        commit('SET_LIVE_VIDEO_IFRAME_VISIBILITY', true)
      } else {
        commit('SET_LIVE_VIDEO_IFRAME_VISIBILITY', false)
      }
    },
    async fetchVideoList({ rootState, commit }, payload) {
      try {
        if (payload?.mode !== 'refresh') {
          commit('SET_LIVE_VIDEO_TABLE_ITEMS', [])
          commit('SET_LIVE_VIDEO_TABLE_LOADING', true)
        }

        const device_id = rootState.auth.selected_device

        const response = await api.getLiveVideoList(device_id)
        if (response.data.success) {
          const dataRes = response?.data?.data?.map((item, idx) => {
            return {
              id: idx,
              ...item
            }
          })
          commit('SET_LIVE_VIDEO_TABLE_ITEMS', dataRes)
          if (payload?.mode === 'banner') commit('INIT_NOTIFICATION_BANNER_REAL_SESSION_ID', { real_session_id: payload.id })
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_LIVE_VIDEO_TABLE_LOADING', false)
      }
    },
    async fetchOfflineHours({ commit }, payload) {
      try {
        commit('SET_OFFLINE_HOUR', [])
        const response = await api.getOfflineHours(payload)
        if (response.data.success) {
          commit('SET_OFFLINE_HOUR', response.data.data.offline_hours)
          commit('SET_OFFLINE_RESPONSES', response.data.data.offline_response)
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      }
    },
    async fetchNotificationChannel({ commit }, payload) {
      try {
        const response = await api.getNotificationChannel(payload)
        if (response.data.success) {
          commit('SET_NOTIFICATION_OPTIONS', response.data.data.options)
          commit('SET_NOTIFICATION_CHANNEL', response.data.data.notification_channel)
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      }
    },
    async updateVideoCallStatus({ rootState, commit }, payload) {
      try {
        const device_id = rootState.auth.selected_device
        const response = await api.updateVideoCallStatus({ device_id: device_id, params: payload })
        if (!response.data.success) throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_LIVE_VIDEO_TABLE_LOADING', false)
      }
    },
    async updateOfflineHour({ rootState, commit, dispatch }, payload) {
      try {
        const device_id = rootState.auth.selected_device
        const response = await api.updateOfflineHours({
          device_id: device_id,
          params: payload
        })
        if (response.data.success) {
          commit('SET_OFFLINE_RESPONSES', payload.offline_response)
          commit('RESET_SET_OFFLINE_HOUR_OF_LIVE_VIDEO_DIALOG')
          dispatch('fetchOfflineHours', device_id)

          commit('SET_SNACKBAR', { status: true, color: 'success', text: Vuetify.locale.t('$vuetify.__SnackBar.update', ''), icon: 'check', timeout: '2000' })
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      }
    }
  }
}
